export class GetPaymentUrlResponse {
  /** (string): Identificador único del pago */
  id: string

  /** (string): URL donde el usuario puede realizar el pago */
  urlPayment: string

  constructor(data: any = {}) {
    this.id = data.id
    this.urlPayment = data.urlPayment
  }
}
